import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ModuleSettings component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    htmlEditorPanel: {
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },

    header: {
      textAlign: 'left',
    },

    titleWrapper: {
      padding: '0 1.6rem 2rem 1.6rem',
    },

    title: {
      color: `${variables.colorV2.text.header}`,
      display: 'flex',
      alignItems: 'center',
      fontSize: '2rem',
      fontWeight: 400,
      justifyContent: 'space-between',
      lineHeight: '2.5rem',
      // paddingBottom: '1rem',
    },

    panel: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      flex: '0 1 auto',
      padding: '2rem 1.6rem',
      overflowY: 'hidden',
    },

    panelContent: {
      height: '100%',
      overflowY: 'auto',
    },

    content: {
      padding: theme.spacing(2),
      height: '100%',
    },

    editModeContainer: {
      padding: '2rem 1.6rem 2rem 1.6rem',
    },
  }),
);
